export default __webpack_public_path__ + "static/media/transfer-blue.87810ac3.svg";